import axiosInstance from 'axios'

const axiosNonce = axiosInstance.create({
  baseURL: UGO.api.url,
  headers: {
    'X-WP-Nonce': UGO.api.nonce,
  },
  // withCredentials: true
})

const axios = axiosInstance.create({
  baseURL: UGO.api.url,
  // withCredentials: true
})

export { axiosNonce, axios }
export default axios
